// Comprehensive React polyfill to fix 'Cannot set properties of undefined (setting 'Children')' error
// This ensures ALL React APIs are globally available before any components load

import React from "react";
import * as ReactDOM from "react-dom/client";

// Create a comprehensive React object with all necessary APIs
const ReactWithFullAPI = {
  ...React,
  // Ensure Children API is available
  Children: React.Children,
  // Ensure all other commonly used React APIs
  createElement: React.createElement,
  createContext: React.createContext,
  forwardRef: React.forwardRef,
  memo: React.memo,
  useEffect: React.useEffect,
  useState: React.useState,
  useLayoutEffect: React.useLayoutEffect,
  useContext: React.useContext,
  useRef: React.useRef,
  useMemo: React.useMemo,
  useCallback: React.useCallback,
  // Add any other React APIs that might be needed
  Fragment: React.Fragment,
  StrictMode: React.StrictMode,
  Suspense: React.Suspense,
  lazy: React.lazy,
};

// Make React globally available with full API
if (typeof window !== "undefined") {
  (window as any).React = ReactWithFullAPI;
  (window as any).ReactDOM = ReactDOM;
}

// Also ensure it's available on globalThis
if (typeof globalThis !== "undefined") {
  (globalThis as any).React = ReactWithFullAPI;
  (globalThis as any).ReactDOM = ReactDOM;
}

export default ReactWithFullAPI;
